export default __webpack_public_path__ + "static/media/doctor3.17e1c320.jpg";